import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { ProposalRequestService } from 'src/app/services/proposal-request.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-proposal-request-vendors-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './proposal-request-vendors-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProposalRequestVendorsGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private ProposalRequestService: ProposalRequestService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'ProposalRequestVendor';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id', 'ProposalRequestId', 'VendorId', 'ExemptVendorId'],
      Proposal: {
        options: { required: false }
      },
      ProposalRequest: {
        options: { required: true }
      },
      order: [
        ['orderBySpotlightVendor', 'ASC'],
        ['orderBySpotlightVendorPriorityLevel', 'ASC']
      ]
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.ProposalRequestService.getProposalRequestVendors(queryObject),
          this.ProposalRequestService.getProposalRequestVendorCount(
            countQueryObject
          )
        ]).subscribe({
          next: ([ProposalRequestVendors, proposalRequestVendorCount]) => {
            params.success({
              rowData: ProposalRequestVendors,
              rowCount: proposalRequestVendorCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
